export const declense = (number: number, singular: string, plural: string) => {
  if (number === 1) {
    return `${number} ${singular}`;
  }

  return `${number} ${plural}`;
};
